export const merchStepToIndexMap: { [key: string]: number } = {
  associatedRelease: 0,
  Color: 1,
  selectedSizes: 2,
  'Upload Image': 3,
  'Design Position': 4,
  productName: 5,
  productPrice: 6,
  isUnlimited: 7,
  quantity: 8,
};

export enum OrderType {
  SAMPLE = 'SAMPLE',
  NORMAL = 'NORMAL',
}

export enum MerchStatus {
  published = 'published',
  draft = 'draft',
  processing = 'processing',
}

export const StandardShippingOption = {
  display_name: 'Standard',
  type: 'fixed_amount',
  delivery_estimate: {
    maximum: {
      unit: 'day',
      value: 5,
    },
    minimum: {
      unit: 'day',
      value: 3,
    },
  },
  tax_behavior: 'inclusive',
  tax_code: 'txcd_92010001',
} as const;

export const ExpressShippingOption = {
  display_name: 'Express',
  type: 'fixed_amount',
  delivery_estimate: {
    maximum: {
      unit: 'day',
      value: 3,
    },
    minimum: {
      unit: 'day',
      value: 1,
    },
  },
  tax_behavior: 'inclusive',
  tax_code: 'txcd_92010001',
} as const;
